import React, { forwardRef, useEffect } from 'react';
import { useField } from 'formik';

import { TextInput, TextInputPropsInterface } from '../text-input';

export interface FormikTextInputPropsInterface extends TextInputPropsInterface {
  name: string;
  type?: string;
  placeholder?: string;
}

export const FormikTextInput = forwardRef<HTMLInputElement, FormikTextInputPropsInterface>(
  (
    {
      label,
      id,
      required,
      hideOptional,
      maxLength,
      hideCharacterCount,
      containerClasses,
      inputClasses,
      helperText,
      inlineAddon,
      disabled,
      trailingAddon,
      onChange,
      autoFocus,
      showBorder = true,
      selectOnFocus = false,
      displayError,
      errorClasses,
      onKeyDown,
      onBlur,
      ...rest
    },
    ref
  ) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field, meta] = useField({ ...rest, required });

    const error = meta.touched && Boolean(meta.error);
    const errorText = meta.touched ? meta.error : '';

    useEffect(() => {
      if (onChange) {
        onChange(field.value);
      }
      // eslint-disable-next-line
    }, [field.value]);

    return (
      <TextInput
        id={id}
        ref={ref}
        inputProps={{ ...rest, ...field }}
        autoFocus={autoFocus}
        onChange={field.onChange}
        error={error}
        disabled={disabled}
        errorText={errorText}
        label={label}
        required={required}
        containerClasses={containerClasses}
        inputClasses={inputClasses}
        helperText={helperText}
        maxLength={maxLength}
        hideCharacterCount={hideCharacterCount}
        inlineAddon={inlineAddon}
        trailingAddon={trailingAddon}
        hideOptional={hideOptional}
        showBorder={showBorder}
        selectOnFocus={selectOnFocus}
        displayError={displayError}
        errorClasses={errorClasses}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      />
    );
  }
);
